/**
 * Where an app's code comes from, in one place for every screen that shows it.
 *
 * `sourceKind` arrived after some apps did: where it is missing, an app with a
 * repository is GitHub and one without is an image, which is what the screens
 * tested before the upload route existed.
 */
export type AppSourceKind = 'GITHUB' | 'DOCKER_HUB' | 'UPLOAD';

export const appSourceKind = (
  env: { sourceKind?: string } | undefined | null,
  hasRepository: boolean
): AppSourceKind => {
  if (env?.sourceKind === 'UPLOAD' || env?.sourceKind === 'DOCKER_HUB') {
    return env.sourceKind;
  }
  if (env?.sourceKind === 'GITHUB') {
    return 'GITHUB';
  }
  return hasRepository ? 'GITHUB' : 'DOCKER_HUB';
};

/** Built by the platform from source (GitHub or an upload), not a published image. */
export const isBuiltFromSource = (kind: AppSourceKind) => kind !== 'DOCKER_HUB';
